import { saleApi } from "./axios";
import { useQuery } from "@tanstack/react-query";
import { ValidateCurrentToken, LogoutSystem } from "../../helpers";
import { ServiceResponseI, SaleSummaryI } from "@interfaces";
import { AxiosError } from "axios";

const token = () => {
  const t = ValidateCurrentToken();
  if (!t) throw new Error("TOKEN INVALIDO");
  return t;
};

const handleErr = (err: unknown): never => {
  const obj = (err as AxiosError).response;
  if (obj?.status === 401) LogoutSystem();
  throw new Error((obj?.data as Error).message);
};

export type SummaryPeriod = "today" | "yesterday" | "week" | "month" | "custom";

export interface GetSummaryParamsI {
  period?:   SummaryPeriod;
  dateFrom?: string;
  dateTo?:   string;
  branchId?: string;
}

const getSummary = async (
  params: GetSummaryParamsI,
): Promise<ServiceResponseI<SaleSummaryI>> => {
  try {
    const p = new URLSearchParams();
    if (params.period)   p.append("period",   params.period);
    if (params.dateFrom) p.append("dateFrom", params.dateFrom);
    if (params.dateTo)   p.append("dateTo",   params.dateTo);
    if (params.branchId) p.append("branchId", params.branchId);

    const { data } = await saleApi.get<ServiceResponseI<SaleSummaryI>>(
      "/summary",
      { params: p, headers: { Authorization: token() } },
    );
    return data;
  } catch (err) {
    return handleErr(err);
  }
};

export const useSaleSummary = (params: GetSummaryParamsI) => {
  const summaryQuery = useQuery(
    ["sale-summary", params],
    () => getSummary(params),
    { refetchOnWindowFocus: false, keepPreviousData: true },
  );
  return { summaryQuery };
};